import * as Groups from './groups';
import * as Vehicles from './vehicles';
import * as AllPartNumberCode from './allPartNumberCode';
import * as AddPartNumberCode from './addPnc';
import * as EditPartNumberCode from './editPnc';
import * as PncInstance from './partNumberCodeInstance';

const Actions = {
  ...Groups,
  ...Vehicles,
  ...AllPartNumberCode,
  ...AddPartNumberCode,
  ...EditPartNumberCode,
  ...PncInstance,
};

export default Actions;
